import { useCallback, useState } from 'react';

export const useTelegram = () => {
  const [webApp, setWebApp] = useState(null);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  
  const initTelegram = useCallback(() => {
    try {
      if (window.Telegram && window.Telegram.WebApp) {
        const tgWebApp = window.Telegram.WebApp;
        
        // Initialiser l'application WebApp
        tgWebApp.expand();
        tgWebApp.enableClosingConfirmation();
        
        // Récupérer les données utilisateur
        if (tgWebApp.initDataUnsafe && tgWebApp.initDataUnsafe.user) {
          setUser(tgWebApp.initDataUnsafe.user);
        }
        
        setWebApp(tgWebApp);
        return true;
      }
      return false;
    } catch (err) {
      setError('Erreur lors de l\'initialisation Telegram: ' + err.message);
      return false;
    }
  }, []);
  
  const showAlert = useCallback((message) => {
    if (webApp) {
      webApp.showAlert(message);
    } else {
      // Fallback pour environnement non-Telegram
      alert(message);
    }
  }, [webApp]);
  
  const showConfirm = useCallback((message, callback) => {
    if (webApp) {
      webApp.showConfirm(message, callback);
    } else {
      // Fallback pour environnement non-Telegram
      const result = window.confirm(message);
      callback(result);
    }
  }, [webApp]);
  
  const showBackButton = useCallback((show = true) => {
    if (webApp) {
      if (show) {
        webApp.BackButton.show();
      } else {
        webApp.BackButton.hide();
      }
    }
  }, [webApp]);
  
  const onBackButtonClicked = useCallback((callback) => {
    if (webApp) {
      webApp.BackButton.onClick(callback);
    }
  }, [webApp]);
  
  const closeWebApp = useCallback(() => {
    if (webApp) {
      webApp.close();
    }
  }, [webApp]);
  
  const sendData = useCallback((data) => {
    if (webApp) {
      webApp.sendData(JSON.stringify(data));
    }
  }, [webApp]);
  
  return {
    webApp,
    user,
    error,
    initTelegram,
    showAlert,
    showConfirm,
    showBackButton,
    onBackButtonClicked,
    closeWebApp,
    sendData,
    isTelegramWebApp: !!webApp
  };
};